import { Component, OnInit } from '@angular/core';
import { ConsultantService } from './consultant.service';
import { ConsultantModel } from './consultant.model';
import { ConsultantConst } from './const';
import { ConsultantDialogDeleteComponent } from './consultant-dialog-delete.component';
import { DummyComponent } from '../../shared/dummy.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ActualSelected } from '../../shared/utils';
import { AuthService } from '../../core/guards/auth/auth.service';
import { ConsultantDialogAccountingReportsComponent } from './accounting-reports/consultant-dialog-accounting-reports.component';
import { ContactModel } from '../contact/contact/contact.model';
import { ContactFormV2Component } from '../../modules_v2/contacts/components/contact-form-v2/contact-form-v2.component';
import { consts } from '../../consts';
import { RegisterModel } from '../../core/authentication/register/register.model';
import { PermissionService } from '../../guards/permission/permission.service';

@Component({
    selector: 'convfact-consultant',
    templateUrl: './consultant.component.html',
    styleUrls: ['./consultant.component.css'],
    standalone: false
})
export class ConsultantComponent implements OnInit {

  public ready = false;
  public headerTableConsultant: any[] = ConsultantConst.headerTable;
  public consultantList: ConsultantModel[] = [];

  public isConsultant: boolean = ActualSelected.isConsultant;
  public isBusinessGroup: boolean = ActualSelected.isBusinessGroup;

  constructor(
    private consultantService: ConsultantService,
    private authService: AuthService,
    private dummy: DummyComponent,
    public dialog: MatDialog,
    private router: Router,
    public snackBar: MatSnackBar,
    public permissionService: PermissionService
  ) { }

  public ngOnInit() {
    ActualSelected.clientActivitySelected = '';
    ActualSelected.clientYearSelected = 0;
    this.consultantService.getList().then(result => {
      this.consultantList = result;
      this.ready = true;
    });
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public edit(uid: string): void {
    this.consultantService.updateRelation(uid).then(result => {
      this.displayInfo(result['message']);
      this.dummy.redirectTo(this.router.url);
    })
  }

  public delete(uid: string): void {
    this.dialog.open(ConsultantDialogDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url);
      });
  }

  public access(clientUid: string): void {
    this.consultantService.viewClient(clientUid)
      .then(responseConsultant => {

        if (responseConsultant) {

          this.authService.logout();

          this.authService.loginAsor("abc", "abc", responseConsultant, "asesor")
            .then(result => {
              if (result) {

                //Roles -- Damos acceso total al perfil que estamos entrando
                const fullAccess: { [key: string]: boolean } = {};
                Object.keys(consts.permissionLabels).forEach(key => {
                  fullAccess[key] = true;
                });

                this.permissionService.setPermissions(fullAccess);
                //-------------------------------------------------

                window.location.href = "/account/contact";
              } else {
                this.displayInfo("No tiene permitido el acceso");
              }
            })
            .catch(err => {
              this.displayInfo("No tiene permitido realizar esta acción")
            });

        }

      })
      .catch(err => {
        this.displayInfo("No tiene permitido realizar esta acción");
      });

  }

  public perdidasyganancias(consultantUids: string[] = ['']): void {

    const usersUids = this.consultantList.filter(x => consultantUids.includes(x.uid)).map(x => x.clientUid);

    this.dialog.open(ConsultantDialogAccountingReportsComponent, {
      data: {
        type: 'perdidasyganancias',
        usersUids: usersUids,
      }
    })
      .afterClosed()
      .subscribe(result => {
      });

  }

  public balancepymes(consultantUids: string[] = ['']): void {

    const usersUids = this.consultantList.filter(x => consultantUids.includes(x.uid)).map(x => x.clientUid);

    this.dialog.open(ConsultantDialogAccountingReportsComponent, {
      data: {
        type: 'balancepymes',
        usersUids: usersUids,
      }
    })
      .afterClosed()
      .subscribe(result => {
      });

  }

  public reports(consultantUids: string[] = ['']): void {

    const usersUids = this.consultantList.filter(x => consultantUids.includes(x.uid)).map(x => x.clientUid);

    this.dialog.open(ConsultantDialogAccountingReportsComponent, {
      data: {
        type: 'reports',
        usersUids: usersUids,
      }
    })
      .afterClosed()
      .subscribe(result => {
      });

  }

  public balancesumasysaldos(consultantUids: string[] = ['']): void {

    const usersUids = this.consultantList.filter(x => consultantUids.includes(x.uid)).map(x => x.clientUid);

    this.dialog.open(ConsultantDialogAccountingReportsComponent, {
      data: {
        type: 'balancesumasysaldos',
        usersUids: usersUids,
      },
    })
      .afterClosed()
      .subscribe(result => {

      });

  }

  public createUser(): void {
    const contactScratch = new ContactModel();
    contactScratch.isProvider = false;
    contactScratch.isClient = true;
    contactScratch.isPhysical = true;

    const dialogNewContact = ContactFormV2Component.open(this.dialog, { scratch: contactScratch });

    dialogNewContact.subscribe((result: ContactModel) => {

      if (result) {
        const register: RegisterModel = {
          CompanyName: result.companyName,
          VatNumber: result.vatNumber,
          Username: result.email,
          Password: '',
          Country: result.country,
          ProvinceCode: result.provinceCode,
          IsConsultant: false,
          Newsletter: false,
          State: result.state,
          Name: '',
          Uid: consts.EMPTY_GUID,
          ParametrizationId: this.getParametrization(result.vatNumber),
          PhoneNumber: result.phone,
          countriesCode: result.countriesCode,
        };

        this.consultantService.registerUser(register)
          .subscribe(result => {
            this.displayInfo(result['message']);
            this.dummy.redirectTo(this.router.url);

          }, err => {
            this.displayInfo(err['error']['message']);
            this.dummy.redirectTo(this.router.url);
          });


      } else {
        this.displayInfo('Parece que ha ocurrido un error durante la crecion del contacto');
      }
    });
  }

  private getParametrization(vatNumber: string): number {
    const juridical: string[] = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'N', 'R', 'U', 'V', 'W'];
    const physical: string[] = ['X', 'Y', 'Z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    if (physical.filter(value => value.startsWith(vatNumber.charAt(0).toUpperCase())).length > 0) {
      return 3;
    }
    else if (juridical.filter(value => value.startsWith(vatNumber.charAt(0).toUpperCase())).length > 0) {
      return 2;
    }
    else {
      return 1003;
    }

  }

  public trackByIndex(i: number) { return i; }

}
